import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Content } from "../core/models/content";
import { ImageContent } from "../core/models/image-content";

@Component({
    selector: "serprobots-message-image-content",
    templateUrl: "image-content.component.html",
    styleUrls: []
})
export class ImageComponent implements OnInit {

    @Input() content: Content = new ImageContent("");

    @Output()
    onImageClick: EventEmitter<boolean> = new EventEmitter<boolean>();

    url!: string;

    constructor() {}

    async ngOnInit(): Promise<void> {
        this.url = (this.content as ImageContent).url;
    }

    imageClick(): void {
        this.onImageClick.emit(true);
        window.open(this.url, "_blank");
    }

}